export const t = (textSize: { desktop: number; mobile: number }) => {
  return `t${textSize.desktop} tm${textSize.mobile}`;
};
